import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "..";
import { GetBondsListColumns } from "./BondsListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IBondsListTableProps {
    ID_Anag: string;
    ID_FideAffidamento: string;
    Data: Dati.CRisAPIPaginePolizza | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _BondsListTable: React.FC<IBondsListTableProps> = React.memo(({ ID_Anag, ID_FideAffidamento, Data, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetBondsListColumns(ID_Anag, ID_FideAffidamento)} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/BondsList/BondsListTable.tsx